import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalComponent} from '../../../../core/components/modal/modal.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {ToastrService} from 'ngx-toastr';
import {DatePipe} from '@angular/common';
import {CalendarService, TimeSlot} from '../../../services/calendar/calendar.service';

@Component({
  selector: 'app-calendar-delete-timeslot-modal',
  imports: [
    ModalComponent,
    TranslocoPipe,
    DatePipe,
  ],
  templateUrl: './calendar-delete-timeslot-modal.component.html',
  styleUrl: './calendar-delete-timeslot-modal.component.scss'
})
export class CalendarDeleteTimeslotModalComponent {
  @Input() open = false;
  @Input() day: string|null = null;
  @Input() timeslot: TimeSlot|null = null;
  @Output() onClose = new EventEmitter<boolean>();

  public submitting = false;

  public constructor(
    private readonly transloco: TranslocoService,
    private readonly planningService: CalendarService,
    private readonly toastr: ToastrService,
  ) {
  }

  public getDayTranslationKey(): string {
    if (!this.day) {
      return '';
    }
    return this.transloco.translate(`calendar.planning.weekdays.${this.day}`);
  }

  public submit(): void {
    if (!this.day || !this.timeslot) {
      return;
    }
    this.planningService.deleteTimeslotFromDay(this.day, this.timeslot).subscribe(
      () => {
        this.onClose.emit(true);
        this.toastr.success(
          this.transloco.translate('calendar.planning.delete-timeslot.success.content'),
          this.transloco.translate('calendar.planning.delete-timeslot.success.title'),
        );
      }, () => {
        this.toastr.error(
          this.transloco.translate('calendar.planning.delete-timeslot.error.content'),
          this.transloco.translate('calendar.planning.delete-timeslot.error.title'),
        )
      }
    )
  }

  public close(deleted: boolean) {
    this.onClose.emit(deleted);
  }
}
